module.exports = __webpack_public_path__ + "static/image/font/pc/bmeuljiro-4@3x.ver2_0_2.jpg?87821e51";